import React from 'react';
import Card from '../components/UI/Card';
import { PageTransition } from '@/components/motion';

function Community() {
  return (
    <PageTransition className="p-6">
      <Card>
        <div className="text-center py-20">
          <div className="text-6xl mb-4">🌐</div>
          <h2 className="text-2xl font-bold text-foreground mb-2">Community</h2>
          <p className="text-muted-foreground mb-1 max-w-md mx-auto">
            Share strategies, provide feedback, and collaborate with other traders.
          </p>
          <p className="text-sm text-muted-foreground/60 mt-4">Coming soon</p>
        </div>
      </Card>
    </PageTransition>
  );
}

export default Community;
